import { hot } from "react-hot-loader/root"

import { App } from "./App"

export default hot(App)
